var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-page"},[_c('NavMenu'),_c('div',{staticClass:"index-text"},[_c('img',{attrs:{"src":_vm.currentImage,"alt":""}})]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("Copyright © 2025 Gong Inc.")]),_c('div',[_vm._v("All rights reserved.")])])
}]

export { render, staticRenderFns }